module.exports = __webpack_public_path__ + "img/GamePopular-title.62764a4f.png";